import { cx } from "cva";
import { type AnchorHTMLAttributes } from "react";

import { OpenInNewIcon } from "../Icon";
import { SubtleButtonProps, variants } from ".";
import styles from "./index.module.css";
export const SubtleButtonExternalBulletLink = ({
  className,
  children,
  align,
  radius,
  width,
  title,
  href,
  target = "_blank",
  rel = "noopener noreferrer",
  disabled,
  onClick,
  ...props
}: Readonly<SubtleButtonProps & AnchorHTMLAttributes<HTMLAnchorElement>>) => (
  <a
    href={href}
    title={title}
    aria-disabled={disabled}
    target={target}
    rel={rel}
    className={cx(variants({ align, radius, width }), styles.bullet, className)}
    tabIndex={disabled ? -1 : undefined}
    onClick={disabled ? (event) => event.preventDefault() : onClick}
    {...props}
  >
    <span className="flex items-start">
      <span aria-hidden={true} className={styles.bulletMarker} />
      <span>
        {children}
        <span className="sr-only">(別ウィンドウで開きます)</span>
        <OpenInNewIcon size="s" className="mb-1 ml-1 inline" />
      </span>
    </span>
  </a>
);
